import React, { useState } from 'react';
import ColorSketch from '@uiw/react-color-sketch';

const MyColorPicker = ({color, setColor}) => {


  return (
    <div className="flex justify-center">
      <ColorSketch
        color={color}
        onChange={(newColor) => setColor(newColor.hex)}
        width="100%"  
        presetColors="none"
        height="500px"
        style={{ border: 'none', boxShadow: 'none' }}
      />
    </div>
  );
};

export default MyColorPicker;
